<template>
	<div class="">
		<div class="flex items-center gap-4">
			<button
				type="button"
				class="focus:z-10 text-icon-primary p-0.5 rounded-full"
				:class="userIsLogged ? '' : ' focus:z-10'"
				@click="toggleSearch"
			>
				<NuxtIcon
					name="search"
					filled
					class="text-icon-primary text-[1.25rem]"
				/>
			</button>
			<ShoppingListMenuCta
				custom-class="!p-0.5 border-none !rounded-full"
			/>
			<button
				type="button"
				class="hover:no-underline flex items-center p-0.5"
				:class="userIsLogged ? 'btn btn-secondary font-normal px-2.5 text-xs py-[.4375rem] bg-[#F8F8F8] border-border-tertiary' : ''"
				@click="handleUserMenuClick"
			>
				<span v-if="userIsLogged" class="flex items-center gap-1">
					{{ userInitials }}

					<NuxtIcon
						name="chevron-down"
						filled
						class="text-base text-icon-primary"
						:class="userIsLogged ? '' : ''"
					/>
				</span>
				<template v-else>
					<NuxtIcon
						name="user"
						filled
						class="text-[1.25rem] text-icon-primary"
					/>
				</template>
			</button>
		</div>

		<ClientTeleport>
			<HeaderNavSecondary v-model:model="vModelData" />
		</ClientTeleport>
	</div>
</template>

<script setup lang="ts">
	import {storeToRefs} from 'pinia';
	import {useCustomerProfileStore} from '~/stores/customerProfile';
	import type {Header} from '~/types/header';
	import {UserState} from '~/stores/crmStateStore';

	const props = defineProps<{
		model: Header
	}>();

	const vModelData = useVModel(props, 'model');

	const customerProfileStore = useCustomerProfileStore();
	const {userIsLogged, profile} = storeToRefs(customerProfileStore);

	const {redirectToCrm} = useCrmRedirect();

	const userInitials = computed(() => {
		const name = profile.value?.personalInfo?.name;
		const surname = profile.value?.personalInfo?.surname;

		if (!name && !surname) {
			return '';
		}

		const nameInitial = name ? name.charAt(0).toUpperCase() : '';
		const surnameInitial = surname ? surname.charAt(0).toUpperCase() : '';

		return nameInitial + surnameInitial;
	});

	function toggleSearch() {
		vModelData.value.visibleCollapsingSearch = !vModelData.value.visibleCollapsingSearch;
		vModelData.value.visibleMobileMenu = false;
		trackHeaderEvent('search_icon_top');
	}

	function handleUserMenuClick() {
		if (!userIsLogged.value) {
			redirectToCrm(UserState.USER_MENU_ANONYMOUS_SLIDEOUT_LOGIN);
			trackHeaderEvent('muj_globus_bonus_top');
		} else {
			vModelData.value.visibleUserMenu = !vModelData.value.visibleUserMenu;
			trackHeaderEvent('user_name_top', `${profile.value?.personalInfo?.name} ${profile.value?.personalInfo?.surname}`);
		}
	}
</script>
